// ヘッダー高さをCSS変数にセット
(function () {
  function setHeaderHeight() {
    var header = document.getElementById('ovl-header-ovl-header');
    if (header) {
      document.documentElement.style.setProperty('--ovl-header-height', header.offsetHeight + 'px');
    }
  }
  document.addEventListener('DOMContentLoaded', setHeaderHeight);
  window.addEventListener('resize', setHeaderHeight);
})();

// Smart Filter & Search price slider decimal fix
document.addEventListener('DOMContentLoaded', function () {
  function toIntString(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return value;
    return String(Math.round(num));
  }

  function formatYenInt(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return value;
    return '¥' + Math.round(num).toLocaleString('ja-JP');
  }

  function stripDecimalsInGFRange(scope) {
    scope = scope || document;

    // 入力欄
    scope.querySelectorAll('.gf-range-min, .gf-range-max').forEach(function (input) {
      if (input.value) input.value = toIntString(input.value);
      if (input.dataset.value) input.dataset.value = toIntString(input.dataset.value);
      if (input.dataset.minValue) input.dataset.minValue = toIntString(input.dataset.minValue);
      if (input.dataset.maxValue) input.dataset.maxValue = toIntString(input.dataset.maxValue);
    });

    // noUi handle の aria
    scope.querySelectorAll('.gf-range-slider .noUi-handle').forEach(function (handle) {
      ['aria-valuenow', 'aria-valuemin', 'aria-valuemax', 'aria-valuetext'].forEach(function (attr) {
        var val = handle.getAttribute(attr);
        if (val) handle.setAttribute(attr, toIntString(val));
      });
    });

    // ツールチップがある場合
    scope.querySelectorAll('.gf-range-slider .noUi-tooltip').forEach(function (tooltip) {
      tooltip.textContent = formatYenInt(tooltip.textContent);
    });

    // pips が小数なら上書き
    scope.querySelectorAll('.gf-range-slider .noUi-value').forEach(function (pip) {
      pip.textContent = formatYenInt(pip.textContent);
    });
  }

  function bindSliderEvents() {
    document.querySelectorAll('.gf-range-slider').forEach(function (slider) {
      if (slider.dataset.ovlBound === '1') return;
      slider.dataset.ovlBound = '1';

      var refresh = function () {
        stripDecimalsInGFRange(slider.closest('.gf-block-content') || slider.parentNode || document);
      };

      // 操作後に整形
      slider.addEventListener('mousedown', function () {
        requestAnimationFrame(refresh);
        setTimeout(refresh, 50);
        setTimeout(refresh, 150);
      });

      slider.addEventListener('touchstart', function () {
        requestAnimationFrame(refresh);
        setTimeout(refresh, 50);
        setTimeout(refresh, 150);
      }, { passive: true });

      document.addEventListener('mouseup', refresh);
      document.addEventListener('touchend', refresh, { passive: true });
      slider.addEventListener('change', refresh);
      slider.addEventListener('input', refresh);
    });
  }

  function runAll() {
    stripDecimalsInGFRange(document);
    bindSliderEvents();

    // Globo/noUi が後から tooltip を差し込むことがあるので少し遅延でも再実行
    setTimeout(function () { stripDecimalsInGFRange(document); }, 100);
    setTimeout(function () { stripDecimalsInGFRange(document); }, 300);
    setTimeout(function () { stripDecimalsInGFRange(document); }, 800);
  }

  runAll();

  window.addEventListener('globoFilterRenderCompleted', function () {
    runAll();
  });
});

// ブラウザバック時にチェックアウトボタンのローディングをリセット
window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    var btn = document.getElementById('checkout-submit');
    if (btn) {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }
});
